import React from "react";
import "./styles/JournalDB.css";

const JournalDB = () => {
  return (
    <div>
      <h1>Journal DB (Journalist)</h1>
      <p>Here you can create, edit, delete your journal‑type articles.</p>
      {/* Later: fetch your journal articles, display them, CRUD */}
    </div>
  );
};

export default JournalDB;
